import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/Images/LogoSpectra.png";
import eyeClose from "../../assets/Images/eye-close.svg";
import eyeOpen from "../../assets/Images/eye-open.svg";
import Cookies from 'js-cookie';
import "../../firebase.js"
// import { toast } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPasswordEye, setConfirmPasswordEye] = useState(false);
  const [error, setError] = useState("");
  const [ipAddress, setIpAddress] = useState("");

  const [userName, setUserName] = useState("");

  const allowedUsers = [
    "manager1@spectra.co",
    // "sagar.kavatra@spectra.co",
    // "piyush.aggarwal@spectra.co"
  ];

  //   const isMobileDevice = () => {
  //   return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  // };

  useEffect(() => {
    // Function to fetch IP address
    const fetchIP = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    };
    fetchIP();
  }, []);

  useEffect(() => {
    let flag_check = Cookies.get('userName');
    // console.log("flag_check",flag_check);
    if (flag_check) {
      let a = Cookies.get('userName');
      let b = Cookies.get('password');
      let c = Cookies.get('userEmail');
      let d = Cookies.get('gmcToken');
      sessionStorage.setItem("userName", a);
      sessionStorage.setItem("password", b);
      sessionStorage.setItem("userEmail", c);
      sessionStorage.setItem("gmcToken", d);


      // navigate("/dashboard");
       if (allowedUsers.includes(userName)) {
          navigate("/dashboradrc")
        } else {
          navigate("/dashboard");
        }
    }
  }, []);

  // {console.log("gmctoken",sessionStorage.getItem('gmcToken'))}

  const handleLogin = async (e) => {
    e.preventDefault();
    const user = email.split("@")[0];

    const authUrl = process.env.REACT_APP_API_URL;
    //  const authUrl = "https://ffamwapi.spectra.co/index.php";
    const authData = {
      Action: "authentication",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      user_name: user,
      user_password: password,
    };
    try {
      const response = await fetch(authUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(authData),
      });
      const data = await response.text();
      const responseData = JSON.parse(data);
      // console.log("API Response:", responseData);
      if (responseData.Status === "Success") {
        // navigate(`/dashboard?user=${email}`);
        sessionStorage.setItem("userName", user);
        sessionStorage.setItem("password", password);
        sessionStorage.setItem("userEmail", responseData.response.name);
        Cookies.set('userName', user, { expires: 7 }); // expires in 7 days
        Cookies.set('password', password, { expires: 7 });
        setUserName(responseData.response.name);

        Cookies.set('userEmail', responseData.response.name, { expires: 7 });
        try {
          const ApiUrl = process.env.REACT_APP_API_URL;
          const RequestBody = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: "pwalogin",
            domainId: user,
            ipaddress: ipAddress,
            status: "1",
          };
          const Response = await fetch(ApiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(RequestBody),
          });
          const response = await Response.json();
          // console.log("response",response)
          if (response) {
            try {
              const ApiUrl = process.env.REACT_APP_API_URL;
              const RequestBody = {
                "Action": "saveDeviceToken",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "user_name": user,
                "user_token": sessionStorage.getItem('gmcToken')
              };
              const Response = await fetch(ApiUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(RequestBody),
              });
              const response = await Response.json();
              // console.log("response",response)
              if (response) {
                try {
                  const ApiUrl = "https://oneml.spectra.co/getNotificationDetailsForFFA";
                  const RequestBody = {
                    "Action": "saveDeviceToken",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "user_name": user,
                    "user_token": sessionStorage.getItem('gmcToken') || ""
                  };
                  const Response = await fetch(ApiUrl, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(RequestBody),
                  });
                  const response = await Response.json();
                  // console.log("response",response)

                } catch (error) {
                  console.error("Error fetching  data:", error);
                }
              }
            } catch (error) {
              console.error("Error fetching  data:", error);
            }
          }
        } catch (error) {
          console.error("Error fetching  data:", error);
        }
        if (allowedUsers.includes(responseData?.response?.name)) {
          navigate("/dashboradrc")
        } else {
          // navigate("/dashboard");
        }
        // navigate("/dashboard");
        // navigate("/dashboradrc")
      } else {
        // toast.warning(responseData.ErrorDesc, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
        setError(responseData.ErrorDesc);
      }
    } catch (error) {
      console.error("Error during authentication:", error);
    }
  };



  const toggleConfirmPasswordView = () => {
    setConfirmPasswordEye(!confirmPasswordEye);
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6 offset-md-3">
          <div className="small-container">
            <form onSubmit={handleLogin}>
              <img src={logo} alt="spectra-logo" className="spectra-logo" />
              <h5>#MakeLifeBetter</h5>
              {error && (
                <p className="text-danger mt-3">
                  Login Failed..Please try again...
                </p>
              )}
              <div className=" form-element mt-3">
                <div className="form-floating log-form mx-auto mb-3 w-75">
                  <input
                    type="text"
                    className="form-control login-input"
                    id="floatingInput"
                    placeholder="admin@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.replace(/\s/g, ""))}
                  />
                  <label htmlFor="floatingInput" className="log-label">
                    User Name
                  </label>
                </div>
                <div className="form-floating log-form mx-auto mb-2 w-75">
                  <img
                    src={confirmPasswordEye ? eyeOpen : eyeClose}
                    alt=""
                    className="password-view-toggle"
                    onClick={toggleConfirmPasswordView}
                  />
                  <input
                    type={confirmPasswordEye ? "text" : "password"}
                    className="form-control login-input"
                    id="floatingPassword"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value.replace(/\s/g, ""))}
                  />
                  <label htmlFor="floatingPassword" className="log-label">
                    Password
                  </label>
                </div>
              </div>
              <button className="btn login-btn w-50 mt-5">Login</button>
              <div className="text-light copyright mt-5">
                <p>
                  Note: If your user id/ password is not working, please connect
                  with "End User Support" team to get your password reset.
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
